<template>
    <div v-if="stepData">
        <div v-if="!from" :class="{'sub-title': true, 'first': first}">{{stepData.handler}} 与 {{stepData.checkStatusText}} 沟通历史记录</div>
        <div class="ax-communication-step">
            <p class="item-info">
                <span class="time">{{stepData.updateTime || stepData.createTime}}</span>
            </p>
            <div class="item-content">{{stepData.handler}}: {{stepData.remark | brToSpace}}</div>
            <template v-if="stepData.attachments.length!==0">
                <ax-down v-for="(fileItem,index) in stepData.attachments" type="ssc" :data="fileItem" :key="index"></ax-down>
            </template>
        </div>
        <template v-if="stepData.replyCommunicate && stepData.replyCommunicate.length">
            <div class="ax-communication-step" v-for=" (stepItem, index) in stepData.replyCommunicate" :key="index">
               <p class="item-info">
                    <span class="time">{{stepItem.updateTime || stepItem.createTime}}</span>
                </p>
               <div class="item-content">{{stepItem.handler}}: {{stepItem.remark | brToSpace}}</div>
               <template v-if="stepData.attachments.length!==0">
                    <ax-down v-for="(fileItem,index) in stepData.attachments" type="ssc" :data="fileItem" :key="index"></ax-down>
                </template>
            </div>
        </template>
    </div>
</template>
<script>
export default {
    props: ['stepData', 'from', 'first'],
    data(){
        return {
            title: `{{user.name}} 发起的沟通`,
        }
    },
    methods: {
    }
}
</script>
<style lang="scss" scoped>
    .sub-title{
        padding-top: 16px;
        margin-top: 15px;
        margin-bottom: 12px;
        font-size: 14px;
        font-weight: 500;
        // margin-left: -7px;
        border-top: 1px solid #E5E5E5;
        &.first{
            padding-top: 0;
            border-top: none;
        }
    }
    .ax-communication-step{
        margin-top: 8px;
        .item-info{
            margin-bottom: 2px;
            color: $des-color;
            line-height: 17px;
            font-size: 12px;
            .time{
                color: $title-color;
                // margin-left: 4px;
            }
            .dept{
              margin-left: 4px;  
            }
        }
        .item-content{
            line-height: 20px;
            color: $value-color;
            font-size: 14px;
            word-break: break-all;
        }
    }
    
</style>